import { render, staticRenderFns } from "./uradio.vue?vue&type=template&id=1247a2aa&"
import script from "./uradio.vue?vue&type=script&lang=js&"
export * from "./uradio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports